import { doc, updateDoc } from "firebase/firestore";

export const choosePower = async ({ db, org }) => {
  console.log("Choosing power mode");
  const orgRef = doc(db, "orgs", org);
  await updateDoc(
    orgRef,
    { chosenPath: "power-startingBalance" },
    { merge: true },
  );
};

export const chooseExpert = async ({ db, org }) => {
  const orgRef = db.collection("orgs").doc(org);
  await updateDoc(orgRef, { chosenPath: "expert", onboarded: true });
};

export const choosePowerStartingBalances = async ({ db, org }) => {
  const orgRef = doc(db, "orgs", org);
  try {
    await updateDoc(
      orgRef,
      { chosenPath: "power-startingBalance" },
      { merge: true },
    );
  } catch (err) {
    console.log("Error: ", err);
  }
};
